import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { hasWindowsAgents: Boolean }

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.element.querySelector("input[type='radio']:checked")?.value
    const needsFullNav =
      (selected === "windows_events" && this.hasWindowsAgentsValue)
    if (needsFullNav) {
      this.element.dataset.turbo = "false"
    } else {
      delete this.element.dataset.turbo
    }
  }
}
